import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '@utils/cn';
import styles from '@/styles/components/Badge.module.scss';

export interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info';
}

const variantStyles: Record<NonNullable<BadgeProps['variant']>, string> = {
  default: styles.default!,
  success: styles.success!,
  warning: styles.warning!,
  danger: styles.danger!,
  info: styles.info!,
};

const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant = 'default', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(styles.badge, variantStyles[variant], className)}
        {...props}
      />
    );
  }
);

Badge.displayName = 'Badge';

export default Badge;
